export default "__VITE_ASSET__bb1c438c__"